import React from 'react'

const HelpCenter = ({Search,searchQuery,setSearchQuery,filteredFAQs}) => {
  return (
    <div className="font-['Poppins'] bg-[#F5F5F5] min-h-screen">
    {/* Header Section */}
    <div className="container mx-auto px-4 md:px-6 pt-6 md:pt-12 pb-12">
      <div className="text-center mb-8">
        <h2 className="text-[#53686A] font-medium mb-2">FAQs</h2>
        <h1 className="text-2xl md:text-3xl text-[#7295B8] font-semibold mb-4">Ask us anything</h1>
        <p className="text-gray-600">Have any questions? We're here to assist you.</p>
      </div>
      
      {/* Search Bar */}
      <div className="max-w-md mx-auto mb-12">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="text"
            className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Search here"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>
      
      {/* FAQ Items Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {filteredFAQs.map((faq) => (
          <div key={faq.id} className=" p-6 rounded-lg  border border-gray-100">
            <div className="flex flex-col md:flex-col">
              <div className="flex-shrink-0 mb-4 md:mb-4">
                <div className="bg-orange-100 p-2 rounded-full inline-flex">
                  {faq.icon}
                </div>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">{faq.question}</h3>
                <p className="text-sm text-gray-600">{faq.answer}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Still have questions section */}
      <div className="mt-12 md:mt-16 flex-col md:flex-row justify-between items-center bg-[#F9F9F9] w-[90%] mx-auto p-2">

        <div className="flex flex-col gap-1 text-left">
        <h3 className="text-lg md:text-xl font-medium text-[#53686A] mb-2">Still have questions?</h3>
        <p className="text-sm md:text-base text-[#53686A] mb-6">
          Can't find the answer you're looking for? Please chat to our friendly team.
        </p>
        </div>
        <div className="">
          <a href="/contact-us" className="w-full md:w-[fit-content] bg-[#174568] hover:bg-gray-800 text-white px-6 py-2 rounded-md transition-colors">
            Get in touch
          </a>
          </div>
      </div>
    </div>
  </div>
  )
}

export default HelpCenter